// removed by extract-text-webpack-plugin
module.exports = {"boxStudent":"src-components-ContentBox-BoxStudent-__BoxStudent-module___boxStudent","boxStudentData":"src-components-ContentBox-BoxStudent-__BoxStudent-module___boxStudentData","name":"src-components-ContentBox-BoxStudent-__BoxStudent-module___name"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentBox/BoxStudent/BoxStudent.module.css
// module id = 157
// module chunks = 0